import classNames from 'classnames';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import { formatPct } from '@/shared/utils/strings';

export const APYText = ({
  value,
  className,
  prefix = false,
  suffix = false,
}: {
  prefix?: boolean;
  value: number;
  className?: string;
  suffix?: boolean;
}) => (
  <div className={classNames('flex items-center gap-x-1', className)}>
    {prefix && <span className="text-white">Earn up to </span>}
    <span className="text-cf-green-3">
      {formatPct(value)} {suffix && 'APY'}
    </span>
  </div>
);

export const BannerCard = ({
  header,
  body,
  isBodyLoading,
  action,
  bannerImg,
  headerClassName,
  bodyClassName = 'gap-y-[3px]',
  className,
  onClick,
}: {
  header: string;
  body: React.ReactNode;
  isBodyLoading: boolean;
  action?: React.JSX.Element;
  bannerImg?: React.JSX.Element;
  headerClassName?: string;
  bodyClassName?: string;
  className?: string;
  onClick?: () => void;
}) => (
  <div
    className={classNames(
      'relative flex justify-between overflow-hidden rounded-md border border-[#303030] bg-cf-gray-3-5 shadow-[0_0_0_1px_rgba(20,20,20,0.22),0_0_14px_0_rgba(0,0,0,0.14),3px_3px_18px_0_rgba(0,0,0,0.08)_inset]',
      className,
      onClick && 'cursor-pointer',
    )}
    onClick={onClick}
  >
    <div className={classNames('flex flex-col py-6 pl-6', bodyClassName)}>
      {header && <span className={classNames('text-16', headerClassName)}>{header}</span>}
      <div className="z-10 whitespace-nowrap text-[32px]">
        {isBodyLoading ? <SkeletonLine width={150} height={32} /> : body}
      </div>
      {action && <div>{action}</div>}
    </div>
    {bannerImg && <div className="absolute right-0 top-0">{bannerImg}</div>}
  </div>
);
